var en = {
  'Home': 'Lol',
  'mappa': 'Map',
  'cantieri': 'construction sites',
  'Altre proposte del costruttore': 'Other proposals from the builder',
  'Referenze del costruttore': 'References from the builder',
  'CANTIERI APERTI': 'OPEN CONSTRUCTION SITES',
  'CANTIERI ESEGUITI IN PASSATO': 'CONSTRUCTION SITES CARRIED OUT IN THE PAST',
  'INFORMAZIONI SUL COSTRUTTORE': 'INFORMATION ABOUT THE BUILDER',
  'Nessun risultato, cambia i filtri di ricerca o allarga la visuale sulla mappa': 'No results, change search filters or widen the map view',
  'Nessuna proposta disponibile per questo costruttore': 'No proposals available for this builder'
};
export default en;